module.exports = __webpack_public_path__ + "img/logo-grey.27c4ed21.jpg";